import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

// Queries
import GetPaymentIrelandPay from '../Queries/GetPaymentIrelandPay';

// Styles
import styles from './index.module.sass';

export default function Ticket({ history, webservice, getCookie }) {
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('Getting result...');
  const [ticketData, setTicketData] = useState({});
  const [onError, setOnError] = useState(false);
  const { t } = useTranslation('ticket');

  const { irelandPayTransactionToken = '' } = useParams();

  const { location = {} } = history;
  const { state } = location;

  const {
    AuthCode = '',
    ObfuscatedAccountNumber = '',
    TransactionHistoryId = '',
    GrossAmt = '',
    CreationDate = '',
  } = ticketData;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);

    async function fetchData() {
      setLoading(true);
      const response = await GetPaymentIrelandPay({
        jsonBody: { order_token: irelandPayTransactionToken, idioma: 1 },
      });

      const { typeMessage = 'error', NewOrderNumber = '' } = response;

      if (typeMessage === 'error') {
        setOnError(true);
        setLoadingMessage('');
        //history.push('/order/error');
      }

      if (NewOrderNumber) {
        const now = new Date();
        const time = now.getTime();
        const expireTime = time + 1000 * 36000;
        now.setTime(expireTime);
        document.cookie = `folioPedido=${NewOrderNumber};expires=${now.toUTCString()};path=/`;
      }

      setTicketData(response);

      setLoading(false);
    }

    if (irelandPayTransactionToken) {
      fetchData();
    } else if (state) {
      const { NewOrderNumber = '' } = state;

      if (NewOrderNumber) {
        const now = new Date();
        const time = now.getTime();
        const expireTime = time + 1000 * 36000;
        now.setTime(expireTime);
        document.cookie = `folioPedido=${NewOrderNumber};expires=${now.toUTCString()};path=/`;
      }

      setTicketData(state);
      setLoading(false);
    } else {
      setLoadingMessage('');
      history.push('/order/error');
    }
  }, [getCookie, webservice, history, irelandPayTransactionToken, state]);

  return (
    <div className={styles.ticket}>
      {(loading && <div className={styles.loadingMessage}>{loadingMessage}</div>) ||
        (!loading && !onError && (
          <div className={styles.container}>
            <div className={styles.ticketTitle}>
              <i className={`material-icons-outlined ${styles.doneIcon}`}>task_alt</i>
              <div className={styles.doneTitle}>{t('doneTitle')}</div>
            </div>
            <div className={styles.ticketMessage}>{t('ticketMessage')}</div>
            <div className={styles.ticketData}>
              <div className={styles.dataTitle}>{t('receipt')}</div>
              <div className={styles.dataNode}>
                <div className={styles.nodetitle}>{t('authorizationCode')}</div>
                <div className={styles.nodeText}>{AuthCode}</div>
              </div>

              {ObfuscatedAccountNumber && (
                <div className={styles.dataNode}>
                  <div className={styles.nodetitle}>{t('cardNumber')}</div>
                  <div className={styles.nodeText}>{ObfuscatedAccountNumber}</div>
                </div>
              )}

              <div className={styles.dataNode}>
                <div className={styles.nodetitle}>{t('transactionID')}</div>
                <div className={styles.nodeText}>{TransactionHistoryId}</div>
              </div>

              <div className={styles.dataNode}>
                <div className={styles.nodetitle}>{t('amount')}</div>
                <div className={styles.nodeText}>${GrossAmt}</div>
              </div>

              <div className={styles.dataNode}>
                <div className={styles.nodetitle}>{t('transactionDate')}</div>
                <div className={styles.nodeText}>{CreationDate}</div>
              </div>
            </div>
            <div className={styles.print}>
              <div
                className={styles.printButton}
                onClick={() => {
                  window.print();
                }}>
                <i className='material-icons-outlined'>print</i>
                <span>{t('printText')}</span>
              </div>
            </div>
          </div>
        )) ||
        (!loading && onError && (
          <div className={styles.container}>
            <div className={styles.ticketTitle}>
              <i className={`material-icons-outlined ${styles.errorIcon}`}>cancel</i>
              <div className={styles.errorTitle}>Error en transacción</div>
            </div>
            <div className={styles.ticketMessage}>La transacción no se ha completado</div>
          </div>
        ))}
    </div>
  );
}
